module.exports = __webpack_public_path__ + "static/media/notes.179b6133.svg";